module.exports = __webpack_public_path__ + "static/zolo-driss-45f23ca2fb45f4f7a82accc0769deac1.jpg";